import { Box, Theme, Typography } from "@outschool/backpack";
import { pathnameWithoutLocale } from "@outschool/routes";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";
import { useLocation } from "react-router";

import { useStickyHeader } from "../../../hooks/useStickyHeader";
import useDashboardLinks from "../hooks/useDashboardLinks";

interface DashboardNavProps {
  learnerBannerHeight: number;
}

export default function DashboardNav({
  learnerBannerHeight,
}: DashboardNavProps) {
  const Link = useLinkComponent();
  const location = useLocation();
  const { headerHeight } = useStickyHeader();
  const dashboardLinks = useDashboardLinks();

  return (
    <Box
      sx={(theme: Theme) => ({
        backgroundColor: "white",
        height: "fit-content",
        py: 10,
        borderRadius: 16,
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
        top: `${learnerBannerHeight + headerHeight + 24}px`,
        position: "sticky",
        zIndex: 199,
      })}
    >
      {dashboardLinks.map(link => {
        const isActive = pathnameWithoutLocale(location.pathname) === link.to;

        return (
          <Link
            to={link.to}
            key={link.label}
            style={{
              textDecoration: "none",
              padding: "20px 0px 20px 32px",
              display: "block",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: isActive ? "black" : "grey.600",
                fontWeight: isActive ? 700 : 500,
              }}
            >
              {link.label}
            </Typography>
          </Link>
        );
      })}
    </Box>
  );
}
